const imageBanner = require('../assets/images/ProcessInfoSimul.svg');
const imageBannerApprove = require('../assets/images/ProcessInfoApproved.svg');
const imageBannerPending = require('../assets/images/ProcessInfoPending.svg');

export const bannerStatus = (status) => {
    const bannerOptions = {
        SIMUL: {
            bannerImage: imageBanner,
            bannerTag: `loansMortgagesBanner-loansMortgagesBannerTagSIMUL`,
            bannerTitle: `loansMortgagesBanner-loansMortgagesBannerTitleEndSIMUL`,
            bannerDescription: `loansMortgagesBanner-loansMortgagesBannerDescriptionSIMUL`,
            bannerButtonPrimary: `loansMortgagesBanner-loansMortgagesBannerButtonPrimary`,
            bannerButtonSecondary: `loansMortgagesBanner-loansMortgagesBannerButtonSecondary`,
            typeTag: 'action',
            step: 1
        },
        APORTAR_DOC: {
            bannerImage: imageBanner,
            bannerTag: `loansMortgagesBanner-loansMortgagesBannerTagSIMUL`,
            bannerTitle: `loansMortgagesBanner-loansMortgagesBannerTitleEndSIMUL`,
            bannerDescription: `loansMortgagesBanner-loansMortgagesBannerDescriptionSIMUL`,
            bannerButtonPrimary: `loansMortgagesBanner-loansMortgagesBannerButtonPrimary`,
            bannerButtonSecondary: `loansMortgagesBanner-loansMortgagesBannerButtonSecondary`,
            typeTag: 'action',
            step: 2
        },
        PRE_APROB: {
            bannerImage: imageBanner,
            bannerTag: `loansMortgagesBanner-loansMortgagesBannerTagSIMUL`,
            bannerTitle: `loansMortgagesBanner-loansMortgagesBannerTitleEndSIMUL`,
            bannerDescription: `loansMortgagesBanner-loansMortgagesBannerDescriptionSIMUL`,
            bannerButtonPrimary: `loansMortgagesBanner-loansMortgagesBannerButtonPrimary`,
            bannerButtonSecondary: `loansMortgagesBanner-loansMortgagesBannerButtonSecondary`,
            typeTag: 'action',
            step: 2
        },
        DOC_PTE_VALIDAR: {
            bannerImage: imageBannerPending,
            bannerTag: `loansMortgagesBanner-loansMortgagesBannerTagDOC_PTE_VALIDAR`,
            bannerTitle: `loansMortgagesBanner-loansMortgagesBannerTitleEndDOC_PTE_VALIDAR`,
            bannerDescription: `loansMortgagesBanner-loansMortgagesBannerDescriptionDOC_PTE_VALIDAR`,
            bannerSecondDescription: `loansMortgagesBanner-loansMortgagesBannerSecondDescriptionDOC_PTE_VALIDAR`,
            bannerDescriptionEmail: `loansMortgagesBanner-loansMortgagesBannerDescriptionEmailDOC_PTE_VALIDAR`,
            bannerDescriptionEnd: `loansMortgagesBanner-loansMortgagesBannerDescriptionEndDOC_PTE_VALIDAR`,
            bannerButtonSecondary: `loansMortgagesBanner-loansMortgagesBannerButtonSecondary`,
            typeTag: 'pending'
        },
        APROBADO: {
            bannerImage: imageBannerApprove,
            bannerTag: `loansMortgagesBanner-loansMortgagesBannerTagAPROBADO`,
            bannerInitTitle: `loansMortgagesBanner-loansMortgagesBannerTitleInitAPROBADO`,
            bannerTitle: `loansMortgagesBanner-loansMortgagesBannerTitleEndAPROBADO`,
            bannerDescription: `loansMortgagesBanner-loansMortgagesBannerDescriptionAPROBADO`,
            bannerButtonPrimary: `loansMortgagesBanner-loansMortgagesBannerButtonPrimary`,
            bannerButtonSecondary: `loansMortgagesBanner-loansMortgagesBannerButtonSecondary`,
            typeTag: 'success'
        }
    }
    return bannerOptions[status]
}

export const bannerShow = (status) => {
    const bannerOptions = [
        'SIMUL',
        'APORTAR_DOC',
        'PRE_APROB',
        'DOC_PTE_VALIDAR',
        'APROBADO']

    return bannerOptions.includes(status)
}